import { useEffect } from "react";
import { toast } from "sonner";
import { http, formatApiError, setEditionState } from "@/lib/api";
import { EDITIONS } from "@/lib/brand";
import { useProfile } from "@/context/ProfileContext";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export const canSwitchEdition = (p) => p && (p.role !== "student" || p.learner_type === "adult");

export const ParentEditionDialog = ({ state, onClose }) => {
  useEffect(() => { const n = sessionStorage.getItem("cl_edition_note"); if (n) { sessionStorage.removeItem("cl_edition_note"); toast.info(n); } }, []);
  const { setStateEdition } = useProfile();
  const go = async (apply_kids) => {
    try {
      const r = (await http.put("/family/edition", { state, apply_kids })).data;
      setEditionState(state); await setStateEdition(state);
      const ok = apply_kids ? `${EDITIONS[state]} set for you and ${r.kids_updated} kid${r.kids_updated === 1 ? "" : "s"}.` : `${EDITIONS[state]} set for you`;
      if (!apply_kids) toast.success(ok);
      else sessionStorage.setItem("cl_edition_note", r.kids_locked ? `${ok} ${r.kids_locked} kid${r.kids_locked === 1 ? "'s" : "s'"} edition is set by their teacher's class and wasn't changed.` : ok);
      onClose();
      if (apply_kids) window.location.reload();
    } catch (e) { toast.error(formatApiError(e)); }
  };
  return (
    <Dialog open={!!state} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-[#FDFBF7]" data-testid="parent-edition-dialog">
        <DialogTitle className="font-display text-2xl text-[#2C4A3E]">Switch to {EDITIONS[state]}?</DialogTitle>
        <DialogDescription>Your kids' lessons, standards and assessments follow their own edition. You can also change one child at a time from their Edit button.</DialogDescription>
        <div className="grid sm:grid-cols-2 gap-2">
          <button onClick={() => go(true)} data-testid="parent-edition-all" className="py-3 rounded-full bg-[#2C4A3E] text-white text-sm">Me and all my kids</button>
          <button onClick={() => go(false)} data-testid="parent-edition-me" className="py-3 rounded-full border border-[#E6DEC3] bg-white text-[#2C4A3E] text-sm">Just me</button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
